"use strict";
/* eslint @typescript-eslint/no-explicit-any: 0 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notImplemented = exports.toPlainValue = exports.applyJsonObject = exports.applyJsonArray = exports.toYDataType = exports.isJSONObject = exports.isJSONArray = exports.isJSONPrimitive = void 0;
const Y = __importStar(require("yjs"));
function isJSONPrimitive(v) {
    const t = typeof v;
    return t === 'string' || t === 'number' || t === 'boolean' || v === null;
}
exports.isJSONPrimitive = isJSONPrimitive;
function isJSONArray(v) {
    return Array.isArray(v);
}
exports.isJSONArray = isJSONArray;
function isJSONObject(v) {
    return !isJSONArray(v) && typeof v === 'object';
}
exports.isJSONObject = isJSONObject;
function toYDataType(v) {
    if (isJSONPrimitive(v)) {
        return v;
    }
    else if (isJSONArray(v)) {
        const arr = new Y.Array();
        applyJsonArray(arr, v);
        return arr;
    }
    else if (isJSONObject(v)) {
        const map = new Y.Map();
        applyJsonObject(map, v);
        return map;
    }
    else {
        return undefined;
    }
}
exports.toYDataType = toYDataType;
function applyJsonArray(dest, source) {
    dest.push(source.map(toYDataType));
}
exports.applyJsonArray = applyJsonArray;
function applyJsonObject(dest, source) {
    Object.entries(source).forEach(([k, v]) => {
        dest.set(k, toYDataType(v));
    });
}
exports.applyJsonObject = applyJsonObject;
function toPlainValue(v) {
    if (v instanceof Y.Map || v instanceof Y.Array) {
        return v.toJSON();
    }
    else {
        return v;
    }
}
exports.toPlainValue = toPlainValue;
function notImplemented() {
    throw new Error('not implemented');
}
exports.notImplemented = notImplemented;
//# sourceMappingURL=util.js.map